module.exports = __webpack_public_path__ + "static/media/joconde.1ee3dbcd.png";